import React from 'react';
import Details from '../Form/Details';
import CourseDescription from './Description';

import Pricing from '../Form/Pricing';
import ProductStatus from '../Form/Status';
import Categories from '../Form/Categories';
import Tags from '../Form/Tags';
import LanguageDropdown from './Language';
import { Media } from 'app/pages/Media';
import CourseMedia from './Media';
import Duration from './Duration';
import LearningOutcomes from './LearningOutcomes';

export default function CourseForm() {
  return (
    <div className="grid grid-cols-12 gap-7">
      <div className="col-span-9">
        <Details />
        <LearningOutcomes />
        <CourseDescription />
        <Pricing />
        <Duration />
        <CourseMedia />
      </div>
      <div className="col-span-3">
        <div className="space-y-4">
          <ProductStatus />
          <div className="bg-white  dark:bg-transparent rounded-lg p-4">
            <h3 className="font-medium text-sm mb-2">Course Filter</h3>
            <Categories />
            <Tags />
            <LanguageDropdown />
          </div>
        </div>
      </div>
    </div>
  );
}
